import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { DateTimeService } from './_services/date-time.service';
import { DatePipe } from '@angular/common';

@Component({
  imports: [DatePipe],
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: true,
})
export class FooterComponent {
  /* properties */

  constructor(
    //Date service to show dynamic year in the footer
    public dateTime: DateTimeService,
    public router: Router,
  ) {}
}
